export const DEFAULT_TURN_TIMER_SECONDS = 20;

const readSetting = (roomData, key) => (
  roomData?.game_state?.settings?.[key] ?? roomData?.settings?.[key]
);

const normalizeSwapLimit = (value, fallback = null) => {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback;
  }
  return Math.floor(parsed);
};

const normalizeTurnTimer = (value, fallback = null) => {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback;
  }
  // Online timer is a fixed gameplay rule. Keep the stored room value canonical
  // so hooks and UI do not have to reason about alternative domain values.
  return Math.min(DEFAULT_TURN_TIMER_SECONDS, Math.floor(parsed));
};

export const resolveRoomSettings = (
  roomData,
  { defaultSwapLimitPerPlayer = null, defaultTurnTimerSeconds = null } = {}
) => ({
  swapLimitPerPlayer: normalizeSwapLimit(readSetting(roomData, 'swapLimitPerPlayer'), defaultSwapLimitPerPlayer),
  turnTimerSeconds: normalizeTurnTimer(readSetting(roomData, 'turnTimerSeconds'), defaultTurnTimerSeconds),
});
